/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.2",
    versionName: "0.2.0-nightly.2026.3.2",
    versionChannel: "nightly",
    buildDate: "2026-03-02T00:09:52.700Z",
    commitHash: "a1ceb30608d54a7a94f81a1425190e4b329aca54",
};
